import { useState } from 'react'
import styled from 'react-emotion'
import { useSelector } from 'react-redux'

import { selectCurrentCompanyId } from 'ducks/crm/companies'
import themeVars from 'ui_theme/site/globals/site.variables'

import useSelectCustomFieldValueForKeyAndType from '../useSelectCustomFieldValueForKeyAndType'
import CompanyHeaderFieldsWithMenuPositioning from './CompanyHeaderFieldsWithMenuPositioning'

export default styled(CompanyHeaderFields)`
  &&& {
    color: ${themeVars.superDarkGray};
    display: flex;
    margin-bottom: 18px;

    &:last-child {
      margin-bottom: 0;
    }

    .nameAndDomain {
      min-width: 0;
      flex-grow: 1;
    }

    .name,
    .email {
      font-size: 11px;
      line-height: 17px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .name {
      font-size: 14px;
      font-weight: ${themeVars.graphikWeightMedium};
      line-height: 21px;
    }

    .action {
      cursor: pointer;
      border-radius: ${themeVars.defaultBorderRadius};
      padding: 2px 3px;
      width: 22px;
      height: 22px;
      text-align: center;
      display: none;
      flex-shrink: 0;
      flex-grow: 0;

      &:hover {
        background: ${themeVars.ultraDust};
      }

      .icon {
        height: ${themeVars.large};
        padding: 0;
        margin: 0;
        color: ${themeVars.ultraLight};
      }
    }

    &:hover {
      .action {
        display: block;
      }
    }
  }
`

function CompanyHeaderFields({ className }) {
  const [openMenu, doSetMenu] = useState(null)
  const companyId = useSelector(selectCurrentCompanyId)
  const domain = useSelectCustomFieldValueForKeyAndType(
    'company_domain',
    'COMPANY'
  )
  const name = useSelectCustomFieldValueForKeyAndType('company_name', 'COMPANY')

  if (!companyId) return null
  return (
    <CompanyHeaderFieldsWithMenuPositioning
      className={className}
      domain={domain}
      name={name}
      doSetMenu={doSetMenu}
      openMenu={openMenu}
      subjectId={companyId}
    />
  )
}
